import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
let currentUser = MethodService.getCurrentUserBS()
let model = {};

// dữ liệu form
model.dataForm = {
    benhvien: null,
    loaikham: null,
    phongkham: null,
    dichvu: null,
    ngaykham: null
};

// validation form
model.validForm = {
    benhvien: [ValidService.required],
    loaikham: [ValidService.required],
    phongkham: [ValidService.required],
    dichvu: [ValidService.required],
    ngaykham: [ValidService.required]
};

model.validForm2A = {
    ma_tinh : [ValidService.required],
    ma_huyen : [ValidService.required],
    ma_xa : [ValidService.required],
    ma_cscl : [ValidService.required],
    ngay_theo_doi : [ValidService.required]
};
model.dataForm2A = {
    ma_tinh: currentUser.MaTinhThanhCSKCB||null,
    ma_huyen: currentUser.MaQuanHuyenCSKCB||null,
    ma_xa: currentUser.MaPhuongXaCSKCB||null,
    ma_cscl: currentUser.MaDiaDiemCachLy||null,
    ngay_theo_doi: MethodService.formatDate3(new Date())
};
model.validForm2B = {
    ma_tinh : [ValidService.required],
    ma_huyen : [ValidService.required],
    ma_xa : [ValidService.required],
    ngay_theo_doi : [ValidService.required]
};
model.dataForm2B = {
    ma_tinh: currentUser.MaTinhThanhCSKCB||null,
    ma_huyen: currentUser.MaQuanHuyenCSKCB||null,
    ma_xa: currentUser.MaPhuongXaCSKCB||null,
    ngay_theo_doi: MethodService.formatDate3(new Date())
};
// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["register_date", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;